import type { QueryClient } from "@tanstack/react-query";
import { EntryType, MediaGroup } from "@/openapi/generated/models";
import { fetchMediaAsset } from "@/lib/utils/media/fetch-media-asset";
import { getMediaAssetQueryKey } from "@/lib/utils/media/media-asset-query-key";

export async function prefetchClassCoverMedia(
  queryClient: QueryClient,
  tenantId: number,
  classId: number,
) {
  if (tenantId <= 0 || classId <= 0) return queryClient;

  await queryClient.prefetchQuery({
    queryKey: getMediaAssetQueryKey(
      tenantId,
      EntryType.Class,
      classId,
      MediaGroup.Cover,
      "public",
    ),
    queryFn: () =>
      fetchMediaAsset({
        tenantId,
        ownerType: EntryType.Class,
        ownerId: classId,
        mediaGroup: MediaGroup.Cover,
      }).catch(() => ({
        url: null,
        mediaId: null,
        media: null,
      })),
  });

  return queryClient;
}
